var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SplaPackagePrices',{attrs:{"productNumber":_vm.productNumber,"packages":_vm.splaPackages,"userEditRight":_vm.userEditRight},on:{"get-spla-packages":_vm.getSplaPackages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }